import { Anchor } from '@cluey/cluey-components';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import iconPencil from '../../assets/images/icon-filled-pencil--orange.svg';
import iconReport from '../../assets/images/icon-filled-report.svg';
import iconStar from '../../assets/images/progressStars/star-100.svg';
import { getPracticeProgress, getUnitCompletion } from '../../selectors/hubSelector';
import { STUDENT_PROGRESS_TAB_VIEWS, STUDENT_PROGRESS_URL_PARAM_TAB } from '../../util/constants';
import { PATH_NAME_REPORT } from '../../util/pagePath';
import SectionTitle from './SectionTitle';

const LearningProgress = ({ reportToken, unitsCompletion, practiceProgress, isProgressLoaded }) => {
  return (
    <div className="mb-8 lg:mb-11">
      <div className="grid grid-cols-12 bg-white px-5 py-6 md:p-10">
        <div className="col-span-12">
          <SectionTitle title="Learning progress" />
        </div>
        <div className="col-span-12 border-b border-grey-2 px-5 py-6 md:col-span-4 md:border-b-0 md:border-r md:px-10">
          <ColumnTitle title="Session reports" />
          <div className="flex items-start">
            <ColumnIcon icon={iconReport} />
            <div className="text-left">
              <p className="font-semibold lg:mb-4">Individual session feedback</p>
              {reportToken && (
                <ColumnCTA
                  to={`${PATH_NAME_REPORT}?token=${reportToken}&${STUDENT_PROGRESS_URL_PARAM_TAB}=${STUDENT_PROGRESS_TAB_VIEWS.SESSION_REPORT}`}
                  label="View reports"
                />
              )}
            </div>
          </div>
        </div>
        {isProgressLoaded && (
          <Fragment>
            <div className="col-span-12 border-b border-grey-2 px-5 py-6 md:col-span-4 md:border-b-0 md:border-r md:px-10">
              <ColumnTitle title="Coverage summary" />
              <div className="flex items-start">
                <ColumnIcon icon={iconStar} />
                <div className="text-left">
                  <p className="mb-2 font-semibold leading-[1.33]">Units completed</p>
                  <p className="mb-2 leading-[1.33]">{unitsCompletion}</p>
                  {reportToken && (
                    <ColumnCTA
                      to={`${PATH_NAME_REPORT}?token=${reportToken}&${STUDENT_PROGRESS_URL_PARAM_TAB}=${STUDENT_PROGRESS_TAB_VIEWS.PROGRESS_OVERVIEW}`}
                      label="View topics and progress"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="col-span-12 py-6 pl-5 pr-0 md:col-span-4 md:pl-10">
              <ColumnTitle title="Practice progress" />
              <div className="flex items-start">
                <ColumnIcon icon={iconPencil} />
                <div className="text-left">
                  <p className="mb-2 font-semibold leading-[1.33]">Practice questions completed</p>
                  <p className="mb-2 leading-[1.33]">{practiceProgress}</p>
                </div>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

LearningProgress.propTypes = {
  reportToken: PropTypes.string,
  unitsCompletion: PropTypes.string,
  practiceProgress: PropTypes.string,
  isProgressLoaded: PropTypes.bool.isRequired,
};

LearningProgress.defaultProps = {
  reportToken: '',
  unitsCompletion: '',
  practiceProgress: '',
};

export default connect((state) => {
  return {
    isProgressLoaded: !state.ui.apiState.hubEnrolmentDetailPage.progressSummary.fetchError,
    unitsCompletion: getUnitCompletion(state),
    practiceProgress: getPracticeProgress(state),
  };
}, null)(LearningProgress);

const ColumnTitle = ({ title }) => {
  return <h3 className="pb-3 font-[Proxima-Soft] text-xs font-bold uppercase tracking-wide">{title}</h3>;
};

ColumnTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

const ColumnIcon = ({ icon }) => {
  return <img src={icon} alt="icon" className="mr-lg-6 mr-5" width={24} height={24} />;
};

ColumnIcon.propTypes = {
  icon: PropTypes.node.isRequired,
};

const ColumnCTA = ({ to, label }) => {
  return (
    <Anchor href={to} target="_blank" className="link">
      {label}
    </Anchor>
  );
};

ColumnCTA.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};
